// removed by extract-text-webpack-plugin
module.exports = {"canvas":"_2dnl-VDuN"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/grid/grid-canvas-sync-fix/grid-canvas-sync-fix.css
 ** module id = 2125
 ** module chunks = 0
 **/